// Products API endpoints

import apiClient from './client';

export const productsAPI = {
  /**
   * Autocomplete search for products
   * @param {Object} params - { part_number: "XXX" } or { description: "XXX" }
   * @returns {Promise} Array of matching products with part_number, description, last_value
   */
  autofill: (params) => apiClient.get('/products/autofill', { params }),

  /**
   * Get all products
   * @returns {Promise}
   */
  getAll: () => apiClient.get('/products'),

  /**
   * Get single product
   * @param {number} id - Product ID
   * @returns {Promise}
   */
  getById: (id) => apiClient.get(`/products/${id}`),

  /**
   * Create product
   * @param {Object} data - Product data
   * @returns {Promise}
   */
  create: (data) => apiClient.post('/products', data),

  /**
   * Update product
   * @param {number} id - Product ID
   * @param {Object} data - Product data
   * @returns {Promise}
   */
  update: (id, data) => apiClient.patch(`/products/${id}`, data),

  /**
   * Delete product
   * @param {number} id - Product ID
   * @returns {Promise}
   */
  delete: (id) => apiClient.delete(`/products/${id}`)
};
